import { render, staticRenderFns } from "./FooterSimple.vue?vue&type=template&id=51d5ffcb&scoped=true"
import script from "./FooterSimple.vue?vue&type=script&lang=js"
export * from "./FooterSimple.vue?vue&type=script&lang=js"
import style0 from "./FooterSimple.vue?vue&type=style&index=0&id=51d5ffcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5ffcb",
  null
  
)

export default component.exports